import React from 'react';
import ChatBot from '../../components/ChatBot/ChatBot';
import './Chat.css';

const Chat = () => {
  return (
    <div className="chat-page-container">
      <div className="chat-page-header">
        <h1 className="chat-page-title">Yoga Health Assistant</h1>
        <p className="chat-page-subtitle">
          Get personalized advice about yoga poses, health benefits, and wellness tips
        </p>
      </div>
      <div className="chat-page-content">
        <ChatBot fullPage={true} />
      </div>
    </div>
  );
};

export default Chat;